import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import { IEventRequestParams } from '../shared.dto';
import { IPassportUrlRedirectionDAO, IPassportUrlRedirectionDTO } from '../passport-url-redirection.dao';

class PassportUrlRedirectionDAO extends IPassportUrlRedirectionDAO {
    static readonly passportUrlRedirectionUrl: string = 'account/{accountId}/event/{eventId}/passport-url-redirection';

    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getPassportUrlRedirection(params: IEventRequestParams): Promise<IPassportUrlRedirectionDTO> {
        const response = await this.apiClient.get<IPassportUrlRedirectionDTO>(PassportUrlRedirectionDAO.passportUrlRedirectionUrl, params);
        return response.parsedResponse;
    }

    public async updatePassportUrlRedirection(params: IEventRequestParams & IPassportUrlRedirectionDTO): Promise<IPassportUrlRedirectionDTO> {
        const response = await this.apiClient.put<IPassportUrlRedirectionDTO>(PassportUrlRedirectionDAO.passportUrlRedirectionUrl, params);
        return response.parsedResponse;
    }
}

export { PassportUrlRedirectionDAO };
